import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createRequestPowerPlayerWindowOutbound } from '../api/outbound/commonOutbounds';
import { PowerPlayerBolt } from '../assets/powerPlayerBolt';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { thunkCloseCurrentMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { PanelItem } from './panelItem';
export const PowerPlayerStatusButtonPanelItem = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const isPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const onClick = useCallback(() => {
        dispatch(thunkCloseCurrentMessageBox());
        socketSend(createRequestPowerPlayerWindowOutbound());
    }, [dispatch, socketSend]);
    return (_jsx(PanelItem, { children: _jsx(Button, { onClick: onClick, variant: 'contained', startIcon: _jsx(PowerPlayerBolt, { color: 'black' }), children: isPowerPlayer ? 'Power Player Status and Upgrades' : 'Upgrade to Power Player' }) }));
};
